<template>
  <v-app-bar app color="white" id="crm-navigation-bar" flat loading>
    <v-col cols="auto" class="mr-4">
      <v-card tile :to="{ name: 'dashboard' }" flat height="64">
        <v-card-text class="pt-1 pb-0">
          <div class="subtitle-2">CRM</div>
          <v-img
            src="@/assets/images/kloner_logo_black.svg"
            width="130"
            height="26"
            contain
          ></v-img>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="auto" class="py-0">
      <v-btn
        height="64"
        color="white"
        active-class="primary"
        depressed
        tile
        :to="{ name: 'customers' }"
        v-if="$can('customers.list')"
      >
        Customers
      </v-btn>

      <v-btn
        height="64"
        color="white"
        active-class="primary"
        depressed
        tile
        :to="{ name: 'projects' }"
        v-if="$can('projects.list')"
      >
        Projects
      </v-btn>

      <v-btn
        height="64"
        color="white"
        active-class="primary"
        depressed
        tile
        :to="{ name: 'tasks' }"
        v-if="$can('tasks.list')"
      >
        Tasks
      </v-btn>

      <v-btn
        height="64"
        color="white"
        active-class="primary"
        depressed
        tile
        :to="{ name: 'workers' }"
        v-if="$can('workers.list')"
      >
        Workers
      </v-btn>
    </v-col>

    <v-spacer></v-spacer>

    <v-col cols="auto" align="right">
      <div>Logged in as: {{ $authUser ? $authUser.name : '' }}</div>
    </v-col>

    <v-col cols="auto" align="right">
      <logout-button text color="secondary">
        Log out
      </logout-button>
    </v-col>

    <v-progress-linear
      height="5"
      absolute
      value="100"
      color="primary"
      bottom
    ></v-progress-linear>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
import LogoutButton from '@/components/auth/LogoutButton'

export default {
  name: 'CrmNavigationBar',
  components: {
    LogoutButton
  },
  computed: {
    ...mapState(['loading']) // TODO
  }
}
</script>
